import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_provider/auth.service';
import { AlertController, NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { HttpService } from '../_provider/http.service';
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService()

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(private http: HttpService, private navCtrl: NavController) { }

  canActivate(): boolean{

    let decoded = helper.decodeToken(this.http.token)
    if(this.http.token != "" && ((decoded.role.includes("employee") || decoded.role == "employee") || decoded.role == undefined)) return true
    else {
      this.navCtrl.navigateRoot("/login")
      return false
    }
  }
}
